export default __webpack_public_path__ + "static/media/3B069A_1_0.83bd9baf.woff";